import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

export default function Address ({ localAddress, setLocalAddress }) {
  const handleStreetChange = event => {
    setLocalAddress(event.target.value)
  }

  return (
    <div className={styles.locationInputWrapper}>
      <div className={styles.inlineLabel}>
        <label className={styles.locationLabel} htmlFor='streetAddress'>
          Street address
        </label>
        <Tooltip
          title='The street address of the business.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Street address help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>
      <input
        className={styles.locationInput}
        type='text'
        id='prevent_autofill'
        autoComplete='off'
        placeholder='Text'
        value={localAddress}
        onChange={handleStreetChange}
      />
    </div>
  )
}
